/**
 * Converts Contentful's "LinkCard" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import LinkCard from 'components/LinkCard'
import { convertRichTextToComponent } from '../utils'

const ContentfulLinkCard = ({
  className, text, href, openInNewTab,
}) => (
  <LinkCard className={className} href={href} target={openInNewTab ? '_blank' : '_self'}>
    {convertRichTextToComponent(text)}
  </LinkCard>
)

ContentfulLinkCard.propTypes = {
  className: PropTypes.string,
  text: PropTypes.object.isRequired,
  href: PropTypes.string,
  openInNewTab: PropTypes.bool,
}

export default ContentfulLinkCard
